// extracted by mini-css-extract-plugin
export default {"container":"PalletsPricingRowLabel_container__dekub"};